import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { userApiClient } from '@/setup/api'

export const getAllTagsQueryOptions = (citySlug: string | undefined, locale: string) =>
    userApiClient.queryOptions(
        'get',
        '/restaurants/tags',
        {
            params: { query: { citySlug } },
            headers: { 'accept-language': locale },
        },
        { enabled: !!citySlug }
    )

export function useGetAllTagsQuery(citySlug: string | undefined) {
    const locale = useLocale()

    return useQuery(getAllTagsQueryOptions(citySlug, locale))
}
